import { Relationship, RelationshipStatus } from '@/types/matching'

const storageKey = (userId: string, relationshipId: string): string =>
  `skyment:rating-prompt-dismissed:${userId}:${relationshipId}`

export const isRatingPromptDismissed = (userId: string, relationshipId: string): boolean =>
  localStorage.getItem(storageKey(userId, relationshipId)) === 'true'

export const dismissRatingPrompt = (userId: string, relationshipId: string): void => {
  localStorage.setItem(storageKey(userId, relationshipId), 'true')
}

/**
 * Find the first completed relationship the given user hasn't rated yet and
 * hasn't permanently dismissed, so the rating modal can be auto-opened for it.
 */
export const findRelationshipNeedingRating = (
  relationships: Relationship[],
  userId: string,
  userRole: 'mentor' | 'mentee'
): Relationship | null => {
  const completed = relationships.filter((r) => r.status === RelationshipStatus.COMPLETED)

  for (const relationship of completed) {
    const myRating = userRole === 'mentor' ? relationship.menteeRating : relationship.mentorRating
    if (!myRating?.ratedAt && !isRatingPromptDismissed(userId, relationship.id)) {
      return relationship
    }
  }

  return null
}
